import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentSpacingStyles, linkStyles } from "@store/theme/common/mixins";
import { tableProps } from "@store/theme/common/props/table";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export interface StoreHistoryTableProps {
    container?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    countText?: TypographyPresentationProps;
    actionCell?: DataTableCellProps;
    actionLink?: LinkPresentationProps;
    actionLoadingOverlay?: LoadingOverlayProps;
}

export const historyTableProps: StoreHistoryTableProps = {
    container: tableProps.overflowWrapper,
    centeringWrapper: {
        css: css`
            height: 150px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 0 1em;
        `,
    },
    noResultsText: {
        forwardAs: "p",
        variant: "h6",
    },
    countText: {
        forwardAs: "p",
        size: TYPOGRAPHY.size.smaller,
        css: css`
            ${contentSpacingStyles()}
        `,
    },
    actionCell: {
        css: css`
            border-left: 1px solid ${getColor("common.border")};
        `,
    },
    actionLink: {
        css: css`
            ${linkStyles()}
            font-weight: ${TYPOGRAPHY.weight.black};
        `,
    },
    actionLoadingOverlay: {
        css: css`
            > div:first-child {
                background-color: transparent;

                &[data-loading="true"] {
                    ~ * {
                        opacity: 0.4;
                    }
                }
            }
        `,
        spinnerProps: {
            size: 20,
            css: css`
                position: relative;
                top: -10px;
                left: -10px;
            `,
        },
    },
};
